import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router';
import { EventType, type AuthenticationResult } from '@azure/msal-browser';

import App from './App.tsx';

import { msalInstance } from './config/msalConfig';
import { SITE_COMPLIANCE_PORTAL_ENABLED } from './config/env';

import '@wk/components-react16/dist/all.min.css';
import './index.css';

if (SITE_COMPLIANCE_PORTAL_ENABLED) {
  document.title = 'WK Site Compliance Portal';
}

msalInstance.initialize().then(async () => {
  // Default to using the first account if no account is active on page load
  if (
    !msalInstance.getActiveAccount() &&
    msalInstance.getAllAccounts().length > 0
  ) {
    const account = msalInstance.getAllAccounts()[0];

    if (account) {
      msalInstance.setActiveAccount(account);
    }
  }

  // Optional - This will update account state if a user signs in from another tab or window
  msalInstance.enableAccountStorageEvents();

  // Listen for sign-in event and set active account
  msalInstance.addEventCallback((event) => {
    const payload = event.payload as AuthenticationResult;
    if (event.eventType === EventType.LOGIN_SUCCESS && payload.account) {
      msalInstance.setActiveAccount(payload.account);
    }
  });

  const { AllCommunityModule, ModuleRegistry, provideGlobalGridOptions } =
    await import('ag-grid-community');

  ModuleRegistry.registerModules([AllCommunityModule]);
  provideGlobalGridOptions({ theme: 'legacy' });

  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <BrowserRouter>
        <App msalInstance={msalInstance} />
      </BrowserRouter>
    </StrictMode>,
  );
});
